import { parsePhoneNumberFromString } from 'libphonenumber-js';

export function toE164(input, defaultCountry = 'AU') {
  if (!input) return '';
  const trimmed = String(input).trim();
  if (/^\+[1-9]\d{1,14}$/.test(trimmed)) return trimmed;
  const parsed = parsePhoneNumberFromString(trimmed, defaultCountry);
  return parsed && parsed.isValid() ? parsed.number : '';
}

export function isE164(input) {
  return /^\+[1-9]\d{1,14}$/.test(String(input).trim());
}

/**
 * 🎯 Enhanced phone validation for blur/submit events
 * Returns { isValid, e164, error } instead of throwing or returning empty strings
 */
export function validatePhoneForBlur(input, defaultCountry = 'AU') {
  if (!input || !input.trim()) {
    return { isValid: false, e164: '', error: null }; // Allow empty for optional fields
  }

  const trimmed = String(input).trim();
  
  // Already valid E.164
  if (/^\+[1-9]\d{1,14}$/.test(trimmed)) {
    return { isValid: true, e164: trimmed, error: null };
  }

  try {
    const parsed = parsePhoneNumberFromString(trimmed, defaultCountry);
    if (parsed && parsed.isValid()) {
      return { isValid: true, e164: parsed.number, error: null };
    } else {
      return { 
        isValid: false, 
        e164: '', 
        error: 'Enter a valid number, e.g., +61412345678' 
      };
    }
  } catch (error) {
    return { 
      isValid: false, 
      e164: '', 
      error: 'Enter a valid number, e.g., +61412345678' 
    };
  }
}

/**
 * 🎯 Check if input contains valid typing characters (no normalization)
 * Allows digits, spaces, parentheses, hyphens, and +
 */
export function isValidPhoneTyping(input) {
  if (!input) return true;
  return /^[+\d\s\-()]*$/.test(String(input));
}


